// @flow
import Users from './Users';
import Activities from './Activities';
import PushNotification from './PushNotification';

export default {
  Users,
  Activities,
  PushNotification,
};



// WEBPACK FOOTER //
// ./src/components/admin/index.js